import { getAll } from '../http/paymentMethodAPI'

let paymentMethods = []

let loadingPromise = null

export const getPaymentMethods = async () => {
    // Уже загружены
   /* if (paymentMethods.length) {
        return paymentMethods
    } */

    // Если запрос уже выполняется — возвращаем его
    if (loadingPromise) {
        return loadingPromise
    }

    loadingPromise = getAll()
        .then(data => {
            paymentMethods = data
            return paymentMethods
        })
        .finally(() => {
            loadingPromise = null
        })

    return loadingPromise
}

export const PaymentMethods = {
    get data() {
        return paymentMethods
    },

    find(callback) {
        return paymentMethods.find(callback)
    },

    filter(callback) {
        return paymentMethods.filter(callback)
    },

    map(callback) {
        return paymentMethods.map(callback)
    },

    some(callback) {
        return paymentMethods.some(callback)
    },

    get length() {
        return paymentMethods.length
    }
}





/*
export const PaymentMethods = [
    {
        name: 'IntellectMoney',
        value: 'intellectmoney',
        method: 'СБП',
        img: '/images/paymentMethods/intellectmoney.png',
        public: true
    },
    {
        name: 'Lava',
        value: 'lava',
        method: 'СБП/Карта',
        img: '/images/paymentMethods/lava.png',
        public: true
    },
    {
        name: 'Enot',
        value: 'enot',
        method: 'СБП/Карта',
        img: '/images/paymentMethods/enot.png',
        public: true
    },
    {
        name: 'RollyPay',
        value: 'rollypay',
        method: 'СБП',
        img: '/images/paymentMethods/rollypay.png',
        public: true
    },
    {
        name: 'USDT',
        value: 'usdt',
        method: 'USDT',
        img: '/images/paymentMethods/usdt.png',
        public: false
    }
] 
    */